export const INITIAL_VALUE_ELEGIBLE = "N";
export const LABEL_COVERAGE_DATE = "Coverage Date";
